<div *ngIf="alert" class="space" [@alert]="evenAlert">
    <div [ngClass]="['alert', alert.options.type]" (click)="closeCurrent()">
        <div *ngIf="alert.options.html" [innerHTML]="alert.message"></div>
        <div *ngIf="!alert.options.html">{{ alert.message }}</div>
    </div>
</div>
